<template>
  <form @submit.prevent="$emit('next')" class="thanks-page col mt-9 mt-lg-0">
    <span>Opções da página</span>

    <form-group
      select
      class="mt-5"
      id="select-option"
      :options="[
        { id: 'default', name: 'Gerar pela ' + $config.get('title') },
        { id: 'external', name: 'Adicionar página externa' }
      ]"
      label="Escolha uma opção"
      placeholder="Escolha uma opção"
      v-model="type"
    />

    <div v-if="type === 'external'">
      <form-group
        v-model="form.url_redirect"
        id="url_redirect"
        label="Compras aprovadas"
        type="text"
        placeholder="Digite a URL"
        :errors="errors.url_redirect"
      />
      <span class="small-text text-secondary">
        Esta página é exibida se a compra for feita com cartão de crédito e já
        estiver aprovada.
      </span>

      <form-group
        class="mt-5"
        v-model="form.url_redirect_credit_analysis"
        id="url_redirect_credit_analysis"
        label="Compras por pix"
        type="text"
        placeholder="Digite a URL"
        :errors="errors.url_redirect_credit_analysis"
      />
      <span class="small-text text-secondary">
        Esta página é exibida se a compra for feita por Pix
      </span>

      <div v-if="form.url_redirect_credit_analysis">
        <b-checkbox v-model="form.has_redirect_pix" class="mt-5">
          Página customizada de pagamento Pix
        </b-checkbox>
        <span class="small-text text-secondary">
          Marcar se deseja utilizar o widget de pagamento Pix. Caso contrário, o
          usuário será redirecionado para a página de obrigado após a aprovação
          do pagamento.
        </span>
      </div>

      <form-group
        class="mt-5"
        v-model="form.url_redirect_waiting"
        id="url_redirect_waiting"
        label="Compras por boleto"
        type="text"
        placeholder="Digite a URL"
        :errors="errors.url_redirect_waiting"
      />
      <span class="small-text text-secondary">
        Esta página é exibida se a compra for feita por boleto bancário e
        estiver aguardando aprovação. Deve ser usada com o widget de boleto.
      </span>

      <div class="d-flex align-items-center mt-5">
        <form-group
          class="flex-fill"
          id="billetScript"
          label="Script para widget de boleto"
          :value="billetScript"
          disabled
        />
        <button
          class="btn btn-sm btn-primary btn-square-sm p-5 mx-3 mt-6"
          type="button"
          id="copy-billet"
          @click="copyBilletScript"
        >
          <i class="fa fa-copy" />
        </button>
      </div>
      <div class="d-flex align-items-center">
        <form-group
          class="flex-fill"
          id="upsellScript"
          label="Script para widget de upsell"
          :value="upsellScript"
          disabled
        />
        <button
          class="btn btn-sm btn-primary btn-square-sm p-5 mx-3 mt-6"
          type="button"
          id="copy-upsell"
          @click="copyUpsellScript"
        >
          <i class="fa fa-copy" />
        </button>
      </div>
      <div class="d-flex align-items-center">
        <form-group
          class="flex-fill"
          id="pixScript"
          label="Script para widget de pix"
          :value="pixScript"
          disabled
        />
        <button
          class="btn btn-sm btn-primary btn-square-sm p-5 mx-3 mt-6"
          type="button"
          id="copy-pix"
          @click="copyPixScript"
        >
          <i class="fa fa-copy" />
        </button>
      </div>
      <span class="small-text text-secondary">
        Os códigos acima devem ser colocados dentro da tag body no código da sua
        página.
        <!-- <a
          target="_blank"
          href="https://ajuda.velora.com.br/article/como-adicionar-um-widget-de-boleto-ou-upsell"
          class="text-primary font-weight-bold text-decoration-none"
        >
          Veja como adicionar um widget à sua página de checkout.
          <i class="fa-solid fa-arrow-up-right-from-square ml-2"></i>
        </a> -->
      </span>
    </div>

    <!-- <hr class="mt-9 mb-9" />

    <div class="d-flex flex-column">
      <span class="font-weight-bold">Idioma</span>
      <span class="text-secondary "
        >Escolha em qual idioma devemos exibir a página de pagamento e enviar
        e-mails aos seus compradores.</span
      >

      <form-group
        type="radio"
        v-model="form.language"
        id="language"
        label=""
        :options="languageOptions"
        :errors="errors.language"
        :customClass="'col-12'"
      />
    </div> -->

    <div class="d-sm-flex d-none justify-content-between mt-9">
      <button
        type="button"
        id="cancel"
        class="btn btn-outline-secondary d-flex align-items-center"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
      <div class="mx-3"></div>
      <button
        type="submit"
        class="btn d-flex align-items-center btn-primary"
        id="submit"
      >
        <loading :show="loading">
          Salvar
        </loading>
      </button>
    </div>
    <div class="d-sm-none justify-content-between mt-9">
      <button
        type="submit"
        class="btn btn-block align-items-center btn-primary"
        id="submit"
      >
        <loading :show="loading">
          Salvar
        </loading>
      </button>
      <div class="m-3"></div>
      <button
        type="button"
        id="cancel"
        class="btn btn-outline-secondary btn-block align-items-center"
        @click="$emit('cancel')"
      >
        <i class="icon-angle-left mr-3" />
        Voltar
      </button>
    </div>
  </form>
</template>

<script>
import copy from "copy-text-to-clipboard";

export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      externalPages:
        this.form.url_redirect !== "" ||
        this.form.url_redirect_waiting !== "" ||
        this.form.url_redirect_credit_analysis !== "",
      type: ""
    };
  },
  watch: {
    type(val) {
      if (val === "default") {
        this.form.url_redirect = "";
        this.form.url_redirect_waiting = "";
        this.form.url_redirect_credit_analysis = "";
      }
    }
  },
  computed: {
    billetScript() {
      return `<iframe id="velora-billet-iframe"></iframe><script src="https://pay.${this.$config.domain}/static/js/billet-client.js"><\/script>`;
    },
    upsellScript() {
      return `<iframe id="velora-upsell-iframe"></iframe><script src="https://pay.${this.$config.domain}/static/js/upsell-client.js"><\/script>`;
    },
    pixScript() {
      return `<iframe id="velora-pix-iframe"></iframe><script src="https://pay.${this.$config.domain}/static/js/pix-client.js"><\/script>`;
    }
  },
  methods: {
    copyBilletScript() {
      copy(this.billetScript);
      this.$message.success("Script copiado!");
    },
    copyUpsellScript() {
      copy(this.upsellScript);
      this.$message.success("Script copiado!");
    },
    copyPixScript() {
      copy(this.pixScript);
      this.$message.success("Script copiado!");
    }
  },
  mounted() {
    this.type = this.externalPages ? "external" : "default";
  }
};
</script>

<style lang="scss" scoped>
.thanks-page {
  .icon-angle-right,
  .icon-angle-left {
    font-size: 24px;
    margin-bottom: 3px;
  }
}
</style>
